var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectronics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 384,
    rx: 40
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 384,
    fill: "#169448"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M298.46,177.71a12,12,0,1,0,0-8H276.79V141.13h21.67a12,12,0,1,0,0-8h-22a29.93,29.93,0,0,0-25.62-25.61V82.27a4,4,0,1,0-8,0v25H214.29v-25a4,4,0,0,0-8,0v25H177.71v-25a4,4,0,0,0-8,0v25H141.13v-25a4,4,0,1,0-8,0v25.25a29.93,29.93,0,0,0-25.62,25.61h-22a12,12,0,1,0,0,8h21.67v28.58H85.54a12,12,0,1,0,0,8h21.67v28.58H85.54a12,12,0,1,0,0,8h21.67v28.58H85.54a12,12,0,1,0,0,8h22a30,30,0,0,0,25.62,25.62v25.24a4,4,0,0,0,8,0V276.79h28.58v24.94a4,4,0,0,0,8,0V276.79h28.58v24.94a4,4,0,0,0,8,0V276.79h28.58v24.94a4,4,0,0,0,8,0V276.49a30,30,0,0,0,25.62-25.62h22a12,12,0,1,0,0-8H276.79V214.29h21.67a12,12,0,1,0,0-8H276.79V177.71Zm7.27-4a4,4,0,1,1,4,4,4,4,0,0,1-4-4Zm0-36.58a4,4,0,1,1,4,4,4,4,0,0,1-4-4Zm-231.46,4a4,4,0,1,1,4-4A4,4,0,0,1,74.27,141.14Zm0,36.57a4,4,0,1,1,4-4A4,4,0,0,1,74.27,177.71Zm0,36.58a4,4,0,1,1,4-4A4,4,0,0,1,74.27,214.29Zm0,36.58a4,4,0,1,1,4-4A4,4,0,0,1,74.27,250.87Zm194.52-4a22,22,0,0,1-21.92,21.92H137.13a22,22,0,0,1-21.92-21.92h0V210.29h0V173.71h0V137.13h0a21.94,21.94,0,0,1,21.92-21.91H246.87a21.94,21.94,0,0,1,21.92,21.91Zm36.94,0a4,4,0,1,1,4,4,4,4,0,0,1-4-4Zm0-36.58a4,4,0,1,1,4,4,4,4,0,0,1-4-4ZM214.55,138.5h-45.1A10.49,10.49,0,0,0,159,149v86a10.49,10.49,0,0,0,10.48,10.48h45.1A10.49,10.49,0,0,0,225,235V149A10.49,10.49,0,0,0,214.55,138.5ZM217,235a2.48,2.48,0,0,1-2.48,2.48h-45.1A2.48,2.48,0,0,1,167,235V149a2.49,2.49,0,0,1,2.48-2.48h45.1A2.49,2.49,0,0,1,217,149Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192.2,223.2a4,4,0,0,1-3.75-5.4L197,195,182.88,199a4,4,0,0,1-4.89-5.15l10.43-30.13a4,4,0,1,1,7.56,2.61l-7.91,22.84,14.3-4.13a4,4,0,0,1,4.86,5.24l-11.29,30.3A4,4,0,0,1,192.2,223.2Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectronics);
export default __webpack_public_path__ + "static/media/electronics.d27a296011429e5c763b533714c203e3.svg";
export { ForwardRef as ReactComponent };